import * as money from './costMath';

function proposedPayment(capital, annualRate, months) {
  const rate = Number(annualRate);
  if (!Number.isFinite(rate) || rate < 0 || !Number.isInteger(months) || months < 1) {
    throw new Error('INVALID_LEASE_PROPOSAL', 'Lease rate and term are invalid', 400);
  }
  if (rate === 0) return money.divide(capital, String(months), 15);
  const monthlyRate = Math.expm1(Math.log1p(rate) / 12);
  const factor = monthlyRate / -Math.expm1(-months * Math.log1p(monthlyRate));
  return money.multiply(capital, factor.toFixed(15));
}

function sum(values) { return values.reduce((a, b) => money.add(a, b), money.decimal('0')); }

function allocation(leaseCosts, operating, asOf, timezone) {
  const cycles = leaseCosts.map(cost => money.leaseCycleAt(cost, asOf, timezone));
  if (!cycles.length || cycles.some(cycle => !cycle)) return null;
  if (cycles.some(cycle => cycle.cycleStart !== cycles[0].cycleStart || cycle.cycleEnd !== cycles[0].cycleEnd)) {
    throw new Error('LEASE_BILLING_CYCLES_DIFFER', 'Lease components must share one billing cycle for this display', 409);
  }
  const cycle = cycles[0];
  const monthly = sum(cycles.map(item => item.payment));
  const total = money.add(monthly, operating);
  const hourly = money.divide(total, cycle.cycleHours, 15);
  const local = money.localClock(Date.parse(asOf), timezone);
  const dayStart = money.zonedMidnightUtc(local.year, local.month, local.day, timezone);
  const nextDay = new Date(Date.UTC(local.year, local.month - 1, local.day + 1));
  const dayEnd = money.zonedMidnightUtc(nextDay.getUTCFullYear(), nextDay.getUTCMonth() + 1, nextDay.getUTCDate(), timezone);
  const dayHours = (Math.min(dayEnd, Date.parse(cycle.cycleEnd), cycle.leaseEnd ?? Infinity) - Math.max(dayStart, Date.parse(cycle.cycleStart), cycle.leaseStart)) / 3600000;
  const elapsedHours = (Date.parse(asOf) - Date.parse(cycle.cycleStart)) / 3600000;
  return {
    monthlyLeasePayment: money.fixed(monthly, 2), monthlyOperatingCost: money.fixed(operating, 2),
    monthlySystemCost: money.fixed(total, 2), dailySystemCost: money.fixed(money.multiply(hourly, String(dayHours)), 2),
    currentSystemCostRate: money.fixed(hourly, 6), accruedMonthCost: money.fixed(money.multiply(hourly, String(elapsedHours)), 6),
    currentLeaseCostRate: money.fixed(money.divide(monthly, cycle.cycleHours, 15), 6),
    billingMonth: { start: cycle.cycleStart, end: cycle.cycleEnd, timezone, hours: money.fixed(cycle.cycleHours, 6) },
    hourly
  };
}

export { proposedPayment, allocation };
